import React from 'react';
import Purchasestable from './purchasestable';

export default function Purchases() {
	return (
		<div id="Purchases" className="tab-pane fade">
			<div className="row" id="settings-field">
				<div className="col-md-2">
					<label className="input-label" htmlFor="order-status">
						Order Status
					</label>
					<select className="form-control" id="order-status">
						<option>All</option>
						<option>Open</option>
						<option>Unapproved</option>
						<option>Parked</option>
						<option>Placed</option>
						<option>Costed</option>
						<option>Receipted</option>
						<option>Completed</option>
						<option>Deleted</option>
					</select>
				</div>
			</div>
			<br />
			{/* <div className="panel panel-default">
				<div className="panel-body"> */}
			<Purchasestable />
			{/* </div>
			</div> */}
		</div>
	);
}
